import { render } from "./ArchaicResults.vue?vue&type=template&id=85730d1c"
import script from "./ArchaicResults.vue?vue&type=script&lang=js"
export * from "./ArchaicResults.vue?vue&type=script&lang=js"

import "./ArchaicResults.vue?vue&type=style&index=0&id=85730d1c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__